import { create } from 'zustand'
import { useShallow } from 'zustand/react/shallow'
import type { CurrentUser, Role } from '@/types'

interface AuthState {
  accessToken: string | null
  user: CurrentUser | null
  /** Роль для предпросмотра интерфейса (только для директора). null = своя роль. */
  previewRole: Role | null
  /** true пока идёт восстановление сессии при старте приложения (тихий refresh). */
  bootstrapping: boolean

  setToken: (token: string) => void
  setUser: (user: CurrentUser) => void
  setPreviewRole: (role: Role | null) => void
  setBootstrapped: () => void
  logout: () => void
}

export const useAuthStore = create<AuthState>((set) => ({
  accessToken: null,
  user: null,
  previewRole: null,
  bootstrapping: true,

  setToken: (token) => set({ accessToken: token }),
  setUser: (user) => set({ user }),
  setPreviewRole: (role) => set({ previewRole: role }),
  setBootstrapped: () => set({ bootstrapping: false }),

  logout: () => set({ accessToken: null, user: null, previewRole: null }),
}))

/**
 * Возвращает эффективную роль пользователя:
 * если директор включил предпросмотр — возвращает previewRole,
 * иначе — реальную роль.
 */
export function useEffectiveRole(): Role | null {
  return useAuthStore(
    useShallow((s) => (s.user?.role === 'director' && s.previewRole ? s.previewRole : s.user?.role ?? null)),
  )
}
